module.exports = __webpack_public_path__ + "static/media/product-512.293ecc1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/product-512.png
// module id = 779
// module chunks = 0